import { ApiRequest, ApiResponse, fetchDataFromAPITyped } from './api-requests';
import { getUserInfo } from './user-service';

export type PasswordResetRequestResponse = {
  message: string;
};

export type PasswordResetResponse = {
  message: string;
};

export const requestPasswordReset = async (
  email: string
): Promise<ApiResponse<PasswordResetRequestResponse | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/requestPasswordReset',
    request: {
      method: 'POST',
      entity: 'user',
      body: { email },
    },
  };
  return fetchDataFromAPITyped<PasswordResetRequestResponse>(apiRequest);
};

export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<ApiResponse<PasswordResetResponse | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/resetPassword',
    request: {
      method: 'POST',
      entity: 'user',
      body: { token, newPassword },
    },
  };
  return fetchDataFromAPITyped<PasswordResetResponse>(apiRequest);
};

export const checkOAuthStatus = async (
  token: string
): Promise<ApiResponse<{ isOAuthUser: boolean } | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/checkOAuthStatus',
    request: {
      method: 'POST',
      entity: 'user',
      body: { token },
    },
  };
  return fetchDataFromAPITyped<{ isOAuthUser: boolean }>(apiRequest);
};
